export const ROUTERS = {
    USER: {
        LOGIN: "Login",
        ForgotPassword: "forgot-password",
        RESETPASSWORD: "reset-password",
        GOOGLELOGINSUCCESS: "/login/oauth2/code/google",
        SIGNUP: "signup",
        VERYFY_ACCOUNT: "verify",
        HOME: "",
        account: "account",
        MYRequest: "MyRequest",
        CONTACT: "Contact",
        SERVICE_CALCULATOR: "/Service/calculator",
        SERVICE_VALUATION: "/Service/Valuation",
        SERVICE_VALUATION_FORM: "/Service/valuation/valuation-form",
        SERVICE_SCULPTURE: "/Service/Sculpture",
        SERVICE_Lookup: "/Service/Lookup",
        SERVICE_ServiceList: "/Service/ServiceList",
        SERVICE_Report: "/Report/:id",
        PAYMENT_CHECKOUT: "/Payment-checkout",
        PAYMENT_success: "/pay/success",
        PAYMENT_FAIL: "/pay/cancel",
        SERVICE_SALE: "/Service/sale",
        BLOG: "Blog",
        BLOG_POST1: "Blog/ask-certification-importance",
        BLOG_POST2: "Blog/ask-fancy-yellow-diamond-below20k",
        BLOG_POST3: "Blog/ask-k-color-diamond-in-pave-ring",
        BLOG_POST6: "Blog/ask-13k-budget-emerald-cut",
        BLOG_POST7: "Blog/ask-engagement-ring-purchase",
        EDUCATION_CARAT: "Education/carat",
        EDUCATION_CUT: "Education/cut",
        EDUCATION_COLOR: "Education/color",
        EDUCATION_CLARITY: "Education/clarity",
        EDUCATION_FLUORESCENCE: "Education/fluorescence",
        DIAMOND: "Diamond",
    }

}


